import { useState } from "react";

export type DataStudioColumnMenuKind = "transform" | "more";

export interface OpenDataStudioColumnMenu {
  columnId: string;
  kind: DataStudioColumnMenuKind;
}

/** Tracks which single column dropdown (Transform wand or "..." more) is open across the profile grid. */
export const useDataStudioColumnMenus = () => {
  const [openMenu, setOpenMenu] = useState<OpenDataStudioColumnMenu | null>(
    null,
  );

  const toggleColumnMenu = (
    columnId: string,
    kind: DataStudioColumnMenuKind,
  ) => {
    setOpenMenu((current) =>
      current?.columnId === columnId && current.kind === kind
        ? null
        : { columnId, kind },
    );
  };

  const closeColumnMenu = () => setOpenMenu(null);

  return { openMenu, toggleColumnMenu, closeColumnMenu };
};
